import { motion, useMotionValue, useSpring, useTransform, useScroll } from "framer-motion";
import { DOCTOR_PHOTO, CENTER } from "./data";
import { EASE } from "./Reveal";

const RotatingBadge = () => (
  <div className="absolute -left-10 bottom-16 w-32 h-32 hidden sm:block" style={{ transform: "translateZ(60px)" }}>
    <div className="absolute inset-0 rounded-full bg-[#FCFBF7]/85 backdrop-blur-xl border border-[#1B3B28]/10" />
    <svg viewBox="0 0 120 120" className="spin-slow absolute inset-0">
      <defs><path id="circ" d="M60,60 m-44,0 a44,44 0 1,1 88,0 a44,44 0 1,1 -88,0" /></defs>
      <text className="f-mono" fontSize="8.2" letterSpacing="1.5" fill="#1B3B28">
        <textPath href="#circ">PAURA ZERO · LASER · MICROSCOPIO · CALMA ·</textPath>
      </text>
    </svg>
    <span className="absolute inset-0 grid place-items-center f-serif italic text-3xl text-[#3E6B48]">0</span>
  </div>
);

export const HeroPortrait = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [7, -7]), { stiffness: 70, damping: 16 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-9, 9]), { stiffness: 70, damping: 16 });
  const { scrollY } = useScroll();
  const py = useTransform(scrollY, [0, 900], [0, 140]);
  const imgScale = useTransform(scrollY, [0, 900], [1.08, 1.2]);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <motion.div style={{ y: py }} className="relative" onMouseMove={onMove} onMouseLeave={reset} data-testid="hero-portrait">
      <div className="absolute -inset-16 rounded-full bg-[radial-gradient(circle_at_50%_40%,rgba(134,200,155,0.55),transparent_62%)] blur-2xl" />
      <motion.div style={{ rotateX: rx, rotateY: ry, transformPerspective: 1100, transformStyle: "preserve-3d" }} className="relative">
        <motion.div
          initial={{ clipPath: "inset(100% 0% 0% 0% round 999px 999px 32px 32px)" }}
          animate={{ clipPath: "inset(0% 0% 0% 0% round 999px 999px 32px 32px)" }}
          transition={{ duration: 1.6, delay: 0.5, ease: [0.76, 0, 0.24, 1] }}
          className="relative aspect-[3/4] w-full overflow-hidden rounded-t-[999px] rounded-b-[2rem] bg-[#E6ECE4] shadow-[0_40px_80px_-30px_rgba(15,35,23,0.45)]"
        >
          <motion.img src={DOCTOR_PHOTO} alt="Dott. Nicola Mauro" style={{ scale: imgScale, transformOrigin: "36% 20%" }} className="absolute top-[-4%] left-0 w-[138%] max-w-none h-auto" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F2317]/45 via-transparent to-transparent" />
          <motion.div
            initial={{ top: "0%", opacity: 0 }}
            animate={{ top: ["0%", "100%"], opacity: [0, 1, 1, 0] }}
            transition={{ duration: 2.4, delay: 1.6, ease: "easeInOut" }}
            className="absolute inset-x-0 h-[2px] bg-[#86C89B] shadow-[0_0_24px_6px_rgba(134,200,155,0.8)]"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.9, ease: EASE }}
          style={{ transform: "translateZ(80px)" }}
          className="absolute -right-4 sm:-right-8 bottom-8 rounded-2xl bg-[#FCFBF7]/85 backdrop-blur-xl border border-[#1B3B28]/10 px-5 py-4 shadow-[0_20px_50px_rgba(27,59,40,0.15)]"
          data-testid="hero-doctor-chip"
        >
          <p className="eyebrow text-[#3E6B48]">Protocolli parodontali</p>
          <p className="f-serif text-2xl text-[#1B3B28] mt-1">Dott. Nicola Mauro</p>
          <p className="text-xs text-[#526356] mt-0.5">presso il {CENTER}</p>
        </motion.div>
        <RotatingBadge />
      </motion.div>
    </motion.div>
  );
};
